
import React, { useState } from "react"
import {injectIntl} from "react-intl";
import {FaFacebookF, FaTwitter, FaLinkedinIn, FaGooglePlusG, FaInstagram} from 'react-icons/fa';
import Link from "../components/LocalizedLink";
import logo from "../images/Logo.png";
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import HubspotForm from 'react-hubspot-form'


const Footer = ({siteTitle, intl}) => {
    const [open, setOpen] = useState(false);

    const onOpenModal = () => setOpen(true);
    const onCloseModal = () => setOpen(false);
    return (
        <footer className="page-footer font-small stylish-color-dark pt-4 julie-footertop">


            {/* Footer Links */}
            <div className="container text-center text-md-left">
                {/* Grid row */}
                <div className="row">
                    {/* Grid column */}
                    <div className="col-md-4 col-sm-12">
                        {/* Content */}
                        <h5 className="font-weight-bold text-uppercase mt-3"><img src={logo}/></h5>
                        <p>{intl.formatMessage({id: "julieDesk_develops_content"})}</p>
                        <div className="mobFoot social">
                            <a className="fb-ic socialBack" href="https://www.facebook.com/juliedesk" target="_blank" rel="noreferrer">
                                <FaFacebookF size={20} color={"black"}
                                             className="fab FaFacebook fa-lg white-text mr-md-5 mr-2 "/>
                            </a>
                            {/* Twitter */}
                            <a className="tw-ic socialBack" href="https://twitter.com/juliedesk" target="_blank" rel="noreferrer">
                                <FaTwitter size={20} color={"black"}
                                           className="fab fa-twitter fa-lg white-text mr-md-5 mr-2 "> </FaTwitter>
                            </a>
                            {/*Linkedin */}
                            <a className="li-ic socialBack" href="https://www.linkedin.com/company/julie-desk/" target="_blank" rel="noreferrer">
                                <FaLinkedinIn size={20} color={"black"}
                                              className="fab fa-linkedin-in fa-lg white-text mr-md-5 mr-2 "> </FaLinkedinIn>
                            </a>
                            {/* Google +*/}
                            <a className="gplus-ic socialBack" href="https://www.instagram.com/julie_desk" target="_blank" rel="noreferrer">
                                <FaInstagram size={20} color={"black"}
                                             className="fab fa-instagram fa-lg white-text mr-md-5 mr-2 "> </FaInstagram>
                            </a>
                        </div>
                    </div>
                    {/* Grid column */}
                    {/* Grid column */}
                    <div className="col-md-1 d-none d-md-block"/>
                    <div className="col-md-2 col-sm-12 mobFoot">
                        {/* Links */}
                        <h5 className="font-weight-bold text-uppercase mt-3">{intl.formatMessage({id: "solution"})}</h5>
                        <ul className="list-unstyled">
                            <li>
                                <Link className="julie" to="/price">{intl.formatMessage({id: "pa_services"})}</Link>
                            </li>
                            <li>
                                <Link className="julie" to="/paul">{intl.formatMessage({id: "marketing_services"})}</Link>
                                {/*<a href="#!" data-localize="paul" className="paul">Marketing Services</a>*/}
                            </li>
                            <li>
                                <Link className="julie" to="/price">{intl.formatMessage({id: "tarif"})}</Link>
                            </li>
                            <li>
                                <a target="_blank" href={process.env.GATSBY_CALENDLY_LINK}
                                   className="teddy">{intl.formatMessage({id: "create_account"})}</a>
                            </li>
                            <li>
                                <Link target="_blank" to="/login"
                                      className="login_in">{intl.formatMessage({id: "log_in"})}</Link>
                            </li>
                        </ul>
                    </div>
                    {/* Grid column */}
                    {/* Grid column */}
                    <div className="col-md-2 col-sm-12 mobFoot">
                        {/* Links */}
                        <h5 className="font-weight-bold text-uppercase mt-3">{intl.formatMessage({id: "resources"})}</h5>
                        <ul className="list-unstyled">
                            {/* <li>
                  <a href="#!" data-localize="testimonials">Testimonials</a>
              </li>*/}
                            <li>
                                <a target="_blank" rel="noreferrer" href={process.env.GATSBY_BLOG_URL}>Blog</a>
                            </li>
                            <li>
                                <a target="_blank" rel="noreferrer" href={process.env.GATSBY_HELP_URL + '/home'}>FAQ</a>
                            </li>
                        </ul>
                    </div>
                    {/* Grid column */}
                    {/* Grid column */}
                    <div className="col-md-3 col-sm-12 mobFoot">
                        {/* Links */}
                        <h5 className="font-weight-bold text-uppercase mt-3 ">{intl.formatMessage({id: "about_us"})}</h5>
                        <ul className="list-unstyled">
                            <li>
                                <a className="julie" onClick={onOpenModal}>{intl.formatMessage({id: "contact_us_footer"})}</a>
                            </li>
                            <li>
                                <Link className="julie" to="/security-policy">{intl.formatMessage({id: "security_policy_footer"})}</Link>
                            </li>
                            <li>
                                <Link className="julie" to="/gdpr">{intl.formatMessage({id: "privacy_footer"})}</Link>
                            </li>
                            <li>
                                <Link className="julie" to="/cookie-policy">{intl.formatMessage({id: "cookie_policy_footer"})}</Link>
                            </li>
                            <li>
                                <Link className="julie" to="/conditions">{intl.formatMessage({id: "terms_and_condition_footer"})}</Link>
                            </li>
                            <li>
                                <Link className="julie" to="/legal-notice">{intl.formatMessage({id: "legal_notice_footer"})}</Link>
                            </li>
                        </ul>
                    </div>
                </div>


                    <Modal open={open} onClose={onCloseModal} center blockScroll={false}>
                        <HubspotForm
                            portalId='3482410'
                            formId='249cd2a8-c432-4d28-a147-0c94a51f2ccf'
                            onSubmit={() => console.log('Submit!')}
                            onReady={(form) => console.log('Form ready!')}
                            loading={<div>Loading...</div>}
                        />
                    </Modal>

                {/*<div className="row">
                     Grid column
                    <div className="col-md-2 col-sm-12 mobFoot social d-md-none">
                        <h5 className="font-weight-bold text-uppercase mt-3 ">&nbsp;</h5>

                             Facebook
                            <a className="fb-ic socialBack" href="https://www.facebook.com/juliedesk" target="_blank" rel="noreferrer">
                                <FaFacebookF size={20} color={"black"}
                                             className="fab FaFacebook fa-lg white-text mr-md-5 mr-2 "/>
                            </a>
                             Twitter
                            <a className="tw-ic socialBack" href="https://twitter.com/juliedesk" target="_blank" rel="noreferrer">
                                <FaTwitter size={20} color={"black"}
                                           className="fab fa-twitter fa-lg white-text mr-md-5 mr-2 "> </FaTwitter>
                            </a>
                            Linkedin
                            <a className="li-ic socialBack" href="https://www.linkedin.com/company/julie-desk/" target="_blank" rel="noreferrer">
                                <FaLinkedinIn size={20} color={"black"}
                                              className="fab fa-linkedin-in fa-lg white-text mr-md-5 mr-2 "> </FaLinkedinIn>
                            </a>
                             Google +
                            <a className="gplus-ic socialBack" href="https://www.instagram.com/julie_desk" target="_blank" rel="noreferrer">
                                <FaInstagram size={20} color={"black"}
                                               className="fab fa-instagram fa-lg white-text mr-md-5 mr-2 "> </FaInstagram>
                            </a>
                    </div>
                </div>*/}
                {/* Grid row */}
            </div>
            {/* Footer Links */}
            {/* Copyright */}
            <div className="julie-footertop-copyright text-left py-3"/>
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <p style={{position: 'relative', bottom: '5px'}}>Copyright © 2024 JulieDesk. {intl.formatMessage({id: "footer.rights"})}.</p>
                    </div>
                </div>
            </div>
            {/* Copyright */}
        </footer>

    )
}

export default injectIntl(Footer);

